@if ((bookingIsDisrupted$ | async) === false) {
  <fin-mmb-promotion
    [order$]="booking$"
    (upsellClicked)="onSelectProduct($event)"
    (redirectToCheckIn)="triggerCheckInModalOpen($event)"
    (goToShoppingCart)="goToShoppingCart()"
    (changeFlightsClicked)="onDisruptionWaiverChangeFlightsClicked()"
  />
}

<section class="mmb-view-card rounded-large pr-xsmall grey-25-bg" data-testid="mmb-view-card">
  <h2 data-testid="mmb-page-heading" class="nordic-blue-900-text font-heading-3 ps-small-b">
    {{ 'MMB.view.flightInformation.heading' | finLocalization }}
  </h2>

  @if ((showChildSafetyNotice$ | async) === true) {
    <div
      data-testid="child-safety-notice"
      class="nordic-blue-900-text ps-medium mr-large-b rounded-large elevation-level-1 alert-100-bg flex flex--column"
    >
      <h2 class="font-heading-3">
        {{ 'MMB.childSafetyNotice.title' | finLocalization }}
      </h2>
      <div class="font-body-1" [innerHtml]="'MMB.childSafetyNotice.content' | finLocalization | finSafe: 'html'"></div>
      <div class="font-body-1 flex flex--end bold-type nordic-blue-900-text">
        <a
          data-testid="kids-in-business-view-requirements-link"
          class="nordic-blue-900-text underline open-modal-link"
          (click)="openKidsInBusinessModal()"
          >{{ 'MMB.childSafetyNotice.link' | finLocalization }}</a
        >
      </div>
    </div>
  }

  <fin-mmb-trip
    [booking$]="booking$"
    [changeFlightModalOpen$]="changeFlightModalOpen$"
    [showTravelExtrasButton]="(products$ | async)?.length && (bookingIsDisrupted$ | async) === false"
    (emailModalOpen)="openEmailModal($event)"
    (scrollToTravelExtras)="scrollTo(travelExtrasSection)"
    (upsellClicked)="onSelectProduct($event)"
    (triggerCheckInRedirection)="triggerCheckInModalOpen($event, true)"
    class="block mr-large-b"
  />

  @if ((bookingIsDisrupted$ | async) === false) {
    <fin-included-products
      [booking]="booking$ | async"
      [showTickets]="false"
      [showInformationModal]="true"
      [useCabinClass]="true"
      [servicesToShow]="combinedServices$ | async"
      [upsellInModal$]="upsellInModal$"
      [titleTranslationKey]="'MMB.labels.includedInTrip'"
      [products$]="products$"
      [categoryStatus]="categoryStatus$ | async"
      [showUpsell]="true"
      [serviceModifyProgress]="serviceModifyProgress$ | async"
      (selectProduct)="onSelectProduct($event)"
      (continuePurchase)="onContinuePurchase()"
      class="services block mr-large-b"
      [mode]="AllowedActionsMode.MMB"
      [groupServicesByBound]="true"
    />
  }

  @if ((unconfirmedServices$ | async)?.length) {
    <fin-included-products
      [booking]="booking$ | async"
      [showTickets]="false"
      [servicesToShow]="unconfirmedServices$ | async"
      [showAsPending]="true"
      [titleTranslationKey]="'MMB.labels.awaitingConfirmation'"
      class="block mr-large-b"
      [mode]="AllowedActionsMode.MMB"
      [groupServicesByBound]="true"
    />
  }

  @if ((products$ | async)?.length && (bookingIsDisrupted$ | async) === false) {
    <fin-section-review
      [title]="'MMB.view.ancillaries.heading' | finLocalization"
      [noButton]="true"
      class="mr-xsmall-b white-bg"
      #travelExtrasSection
    >
      <ng-container ngProjectAs="content">
        <p>{{ 'MMB.view.ancillaries.text' | finLocalization }}</p>
      </ng-container>
    </fin-section-review>
  }

  @if (
    (bookingIsDisrupted$ | async) === false && (booking$ | async).eligibilities.serviceCatalog.isAllowedToUse === true
  ) {
    <fin-mmb-ancillaries
      (emailModalOpen)="openEmailModal($event)"
      (scrollToTravelExtras)="scrollTo(travelExtrasSection)"
      [openAncillarySubview$]="openAncillarySubview$"
      [products$]="products$"
      [order$]="booking$"
    />
  }

  @if ((visibleAllianzBannerId$ | async) === TravelInsuranceEligibilityId.TRAVEL_INSURANCE_48_HOUR) {
    <fin-ancillary-cta-banner
      data-testid="allianz-48h-banner"
      backgroundColorClass="nordic-blue-50-bg"
      [title]="'MMB.allianz.from24hTo48hBanner.title' | finLocalization"
      [href]="'MMB.allianz.from24hTo48hBanner.href' | finLocalization"
      [customIconForLogo]="CustomIcon.ALLIANZ_LOGO"
      [mainText]="'MMB.allianz.from24hTo48hBanner.mainText' | finLocalization"
      [buttonText]="'MMB.allianz.from24hTo48hBanner.buttonText' | finLocalization"
      class="mr-small-b block"
    />
  } @else if ((visibleAllianzBannerId$ | async) === TravelInsuranceEligibilityId.TRAVEL_INSURANCE) {
    <fin-ancillary-cta-banner
      data-testid="allianz-after-48h-banner"
      backgroundColorClass="nordic-blue-50-bg"
      [title]="'MMB.allianz.after48hBanner.title' | finLocalization"
      [href]="'MMB.allianz.after48hBanner.href' | finLocalization"
      [customIconForLogo]="CustomIcon.ALLIANZ_LOGO"
      [mainText]="'MMB.allianz.after48hBanner.mainText' | finLocalization"
      [buttonText]="'MMB.allianz.after48hBanner.buttonText' | finLocalization"
      class="mr-small-b block"
    />
  }

  @if ((bookingIsDisrupted$ | async) === false) {
    <div class="mr-medium-b">
      @if (enableShowingSAF) {
        <fin-sustainability-review-card [isLinkExternal]="true" [showHeader]="false" />
      }
      <fin-promotion-banners [orderData$]="booking$" />
    </div>
  }
</section>

<fcom-modal
  [title]="(isTravelExtraModal ? 'MMB.login.email.travelExtras.title' : 'MMB.login.group.title') | finLocalization"
  [buttons]="ModalButtons.CUSTOM"
  [fitToContent]="true"
  (close)="onEmailModalClose()"
  [isOpen]="showGroupBookingEmailModal$ | async"
>
  <div class="block pr-large">
    <h2 class="nordic-blue-900-text font-heading-3 mr-small-b">
      {{ 'MMB.login.email.heading' | finLocalization }}
    </h2>
    <p class="mr-small-b">
      {{ (isTravelExtraModal ? 'MMB.login.email.travelExtras.info' : 'MMB.login.email.info') | finLocalization }}
    </p>

    <form [formGroup]="groupEmailForm" (ngSubmit)="onSubmitEmail()" data-group-booking-email-form>
      <fin-form-fields>
        <fin-form-group
          class="block pr-xsmall-b"
          [translationPrefix]="'paxDetails.fields'"
          [group]="groupEmailForm"
          [inline]="true"
        >
          <fin-input-field
            [translationPrefix]="'paxDetails.fields.email'"
            class="block pr-xsmall-b"
            [group]="groupEmailForm"
            [modelName]="'email'"
            [type]="'email'"
            [required]="true"
            [name]="'email'"
            (focus)="focusEvent.emit($event)"
            (blur)="blurEvent.emit()"
          />
        </fin-form-group>
      </fin-form-fields>
    </form>

    @if (groupModalError$ | async; as error) {
      <fcom-notification [theme]="NotificationTheme.ALERT" [layout]="NotificationLayout.BLOCK" aria-live="polite">
        {{ 'MMB.login.errors.' + error | finLocalization }}
      </fcom-notification>
    }
  </div>

  <div buttons>
    @if ((loading$ | async) === false) {
      <fcom-button
        [type]="ButtonType.SUBMIT"
        data-testid="group-booking-email-submit"
        [disabled]="!groupEmailForm.valid"
        (clickBtn)="onSubmitEmail()"
        [text]="'actions.continue' | finLocalization"
        [aria]="{ label: 'actions.continue' | finLocalization, role: 'button' }"
        class="mr-xsmall-r"
      />
    }
    @if (loading$ | async) {
      <fcom-loader class="pr-xsmall block" [loaderType]="LoaderTheme.INLINE" />
    }
  </div>
</fcom-modal>

<fcom-modal
  [open]="kidsInBusinessModalOpen$ | async"
  [title]="'kidsInBusinessNotification.modalTitle' | finLocalization"
  [buttons]="ModalButtons.CLOSE"
  [fullHeight]="true"
  (close)="closeKidsInBusinessModal()"
  data-testid="kids-in-business-modal"
>
  <div class="nordic-blue-900-text pr-large-x pr-small-y">
    @for (article of content$ | async; track article; let index = $index) {
      <cms-rich-text
        [attr.data-testid]="'kids-in-business-content-' + (index + 1)"
        [content$]="article | finToObservable"
        [headerStyles]="['font-heading-4']"
      />
    }
  </div>
</fcom-modal>
<fcom-modal
  [open]="(unpaidServicesInCartModal$ | async).isOpen === true"
  [title]="'MMB.promotion.unpaidItems.modalTitle' | finLocalization"
  [buttons]="null"
  [fullHeight]="true"
  (close)="closeUnpaidItemsModal()"
  data-testid="unpaid-services-in-cart-modal"
>
  <div class="nordic-blue-900-text pr-large-x pr-small-y">
    <cms-rich-text
      data-testid="unpaid-items-content"
      [content$]="unpaidItemsModalContent$"
      [headerStyles]="['font-heading-4']"
    />
  </div>
  <div class="fill ps-small-t pr-xlarge-b pr-large-x flex flex--center flex--column">
    <fcom-button
      class="mr-small-b"
      [text]="'MMB.promotion.unpaidItems.modalPayItemsButton' | finLocalization"
      [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
      [mode]="ButtonMode.FILL_MOBILE"
      [icon]="{ name: SvgLibraryIcon.SHOPPING_CART, position: IconPosition.LEFT }"
      [loading]="clearingServicesInProgress$ | async"
      (clickBtn)="goToShoppingCart()"
    />
    <fcom-button
      [text]="
        ((isBoardingPassAvailable$ | async) === true
          ? 'MMB.promotion.unpaidItems.modalContinueToBoardingPassButton'
          : 'MMB.promotion.unpaidItems.modalContinueToCheckInButton'
        ) | finLocalization
      "
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      [mode]="ButtonMode.FILL_MOBILE"
      [loading]="clearingServicesInProgress$ | async"
      (clickBtn)="redirectToCheckIn()"
    />
  </div>
</fcom-modal>
